export default __webpack_public_path__ + "static/media/arcade-btn(sml).fcbd3c9a.jpg";